export const isDefined = (val?: number): val is number => val !== undefined;

/**
 * Return a `fallback` if the `val` is not defined
 */
export const getNumericFallback = (fallback: number, val?: number): number =>
  isDefined(val) ? val : fallback;
